import { useNavigate } from "react-router";

import Loader from "../../loader/Loader";
import "./Button.css";
import { NavigationType } from "../../../../utility/types/generaTypes";

type ButtonProps = {
  title: string;
  className?: string;
  isSecodary?: boolean;
  onClickButton?: () => void;
  onMouseLeave?: () => void;
  onMouseEnter?: () => void;
  rightComponent?: any;
  display?: string;
  backgroundColor?: string;
  borderColor?: string;
  leftComponent?: any;
  border?: string;
  isLoading?: boolean;
  to?: string;
  params?: string;
  color?: string;
  disabled?: boolean;
  style?: any;
  path?: string;
  pathType?: NavigationType;
};

const Button = ({
  title,
  className,
  isSecodary,
  onClickButton,
  rightComponent,
  display,
  backgroundColor,
  borderColor,
  leftComponent,
  border,
  isLoading,
  to,
  params,
  color,
  disabled,
  style,
  onMouseLeave,
  onMouseEnter,
  path,
  pathType,
}: ButtonProps) => {
  const navigate = useNavigate();

  function onClick(e: any) {
    if (disabled) return;

    if (path) {
      window.open(path, pathType); // or "_self"
    } else if (to) {
      navigate(to, { state: params });
    } else if (onClickButton) {
      onClickButton();
    }
  }
  return (
    <div
      className={`${className} buttonContainer ${disabled && "disabledText"}`}
      onClick={(e) => onClick(e)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        background: backgroundColor
          ? backgroundColor
          : isSecodary
          ? "transparent"
          : "rgba(0, 123, 255, 1)",
        border:
          border ||
          `1px solid ${
            borderColor || backgroundColor || "rgba(0, 123, 255, 1)"
          } `,
        color: color ? color : isSecodary ? "rgba(0, 123, 255, 1)" : "white",
        cursor: "pointer",
        display: display || "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        ...style,
      }}
    >
      {isLoading ? (
        <Loader style={{ width: ".7rem", height: ".7rem" }} />
      ) : (
        <>
          {leftComponent ? leftComponent : null}
          {/* {path ? <a href={path}>{title}</a> : title} */}
          {title}
          {rightComponent ? rightComponent : null}
        </>
      )}
    </div>
  );
};

export default Button;
